<script setup lang="ts">
import { useModalStore } from "@/stores/modals/modals.store";
import type { Material } from "@/types/Views/MaterialDatabase/Material";

import CompareView from "../Compare/CompareView.vue";

// Thin modal wrapper around the shared, modal-agnostic CompareView (RTLCA-5064). Keeps the existing
// modals.open("CompareModal", …) contract intact for the Material Mapping view, while the Library uses
// CompareView directly on the /library/compare page.
const props = defineProps<{
  materials: Material[];
  onClear: () => void;
  onRemove?: (id: string) => void;
}>();

const modals = useModalStore();

// Compose the host's clear with closing the modal — CompareView itself no longer knows about modals.
const handleClear = () => {
  props.onClear();
  modals.close();
};
</script>

<template>
  <CompareView
    :materials="props.materials"
    :on-clear="handleClear"
    :on-remove="props.onRemove" />
</template>
